import React from 'react'

export function Card({ className = '', children, variant = 'default', ...props }) {
  const variants = {
    // Deep Tech Noir variants following design specifications
    default: 'rounded-xl border border-electric-blue/20 bg-deep-navy/50 backdrop-blur-sm',
    tech: 'rounded-xl border-2 border-electric-blue/30 bg-deep-charcoal/80 backdrop-blur-md shadow-deep-tech',
    interactive: 'rounded-xl border border-electric-blue/20 bg-deep-navy/60 backdrop-blur-md hover:border-electric-blue/40 hover:shadow-interactive transition-all duration-300',
    showcase: 'rounded-xl border-2 border-electric-blue/30 bg-deep-navy/60 backdrop-blur-xl shadow-deep-tech hover:shadow-electric transition-all duration-500',
    pillar: 'rounded-xl border border-electric-blue/20 bg-deep-navy/50 backdrop-blur-sm hover:border-electric-blue/40 transition-all duration-300',
    // Legacy variants for backwards compatibility
    glass: 'rounded-xl border border-white/10 bg-white/5 backdrop-blur-md',
    glow: 'rounded-xl border border-electric-blue/30 bg-deep-navy/50 backdrop-blur-sm shadow-electric',
    gradient: 'rounded-xl border border-gray-800/50 bg-gradient-to-br from-deep-navy/80 to-deep-charcoal/80 backdrop-blur-sm',
    neon: 'rounded-xl border-2 border-electric-blue/50 bg-deep-charcoal/60 backdrop-blur-md shadow-electric hover:shadow-interactive transition-all duration-300',
    electric: 'rounded-xl border-2 border-electric-400/50 bg-deep-charcoal/60 backdrop-blur-md shadow-electric hover:shadow-interactive transition-all duration-300',
    cyber: 'rounded-xl border-2 border-tech-cyan/50 bg-deep-charcoal/60 backdrop-blur-md hover:shadow-interactive transition-all duration-300'
  }
  
  return (
    <div 
      className={`${variants[variant]} ${className}`}
      {...props}
    >
      {children}
    </div>
  )
}